import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCart = createSelector(cartState, (cart) => cart);
